export default {
	tabs: ["Innskudd", "Historie"],
	History: {
		tabs: ["Gjennomgang", "Suksess", "Avslå"]
	},
	AccountAmount: "Kontobeløp",
	ContactCustomerService: "Kontakt Kundeservice",
	NoCustomerService: "Kundeservice Opptatt",
	tips: "Vennligst send inn den forrige vurderingen før du fortsetter med den neste vurderingen!"
};
